export const ACTIVE_TAB_QUERY_ARG = 'active_tab';
export const MODAL_QUERY_ARG = 'modal';
export const NAME_QUERY_ARG = 'name';
export const EMAIL_QUERY_ARG = 'email';
export const SEARCH_QUERY_ARG = 'search';
export const SOURCE_QUERY_ARG = 'source';
export const PAGE_QUERY_ARG = 'page';
export const SORT_QUERY_ARG = 'sort';
export const DIRECTION_QUERY_ARG = 'direction';
export const TYPE_QUERY_ARG = 'type';
export const STATUS_QUERY_ARG = 'status';
export const OBJECTIVE_QUERY_ARG = 'objective';
export const ARCHIVED_QUERY_ARG = 'archived';
export const DELETED_QUERY_ARG = 'deleted';

export const REDIRECT_TO_QUERY_ARG = 'redirect_to';
export const REDIRECT_LABEL_QUERY_ARG = 'redirect_label';

export const PENDING_TEMPLATES_QUERY_ARG = 'template_ids';

export const DRAFT_SCRIPT_QUERY_ARG = 'draft_script';

export const queryArgs = [
    ACTIVE_TAB_QUERY_ARG,
    MODAL_QUERY_ARG,
    NAME_QUERY_ARG,
    EMAIL_QUERY_ARG,
    SEARCH_QUERY_ARG,
    SOURCE_QUERY_ARG,
    PAGE_QUERY_ARG,
    SORT_QUERY_ARG,
    DIRECTION_QUERY_ARG,
    TYPE_QUERY_ARG,
    STATUS_QUERY_ARG,
    OBJECTIVE_QUERY_ARG,
    ARCHIVED_QUERY_ARG,
    DELETED_QUERY_ARG,

    REDIRECT_TO_QUERY_ARG,
    REDIRECT_LABEL_QUERY_ARG,

    PENDING_TEMPLATES_QUERY_ARG,

    DRAFT_SCRIPT_QUERY_ARG,
] as const;

export type AppQueryArg = (typeof queryArgs)[number];
